module.exports = __webpack_public_path__ + "img/physical.1014c6ef.jpg";